import { render } from "./RenovaRodape.vue?vue&type=template&id=61e47348&scoped=true"
import script from "./RenovaRodape.vue?vue&type=script&lang=js"
export * from "./RenovaRodape.vue?vue&type=script&lang=js"

import "./RenovaRodape.vue?vue&type=style&index=0&id=61e47348&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61e47348"]])

export default __exports__